import React, { useEffect, useRef, useState } from "react";
import { unstable_batchedUpdates } from "react-dom";
import CityDropdowns from "../components/CityDropdowns";
import { RecruitmentRow1 } from "../components/DataRow";
import Navbar from "../components/Navbar";
import { useScrollRestoration } from "../hooks/useScrollRestoration";

const STORAGE_KEY = "keywordSearchState";
const rowCount = 100;

const KeywordSearch = () => {
  const [list, setList] = useState([]);
  const [city, setCity] = useState("");
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [flag, setFlag] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const restoringFromCache = useRef(false);

  // 使用 ref 保存当前状态，用于保存时获取最新值
  const stateRef = useRef({ list, city, keyword, page });

  // 更新 ref
  useEffect(() => {
    stateRef.current = { list, city, keyword, page };
  }, [list, city, keyword, page]);

  // 使用滚动恢复 Hook
  useScrollRestoration({
    stateRef,
    setStates: (parsed) => {
      restoringFromCache.current = true;
      unstable_batchedUpdates(() => {
        if (parsed.list) setList(parsed.list);
        if (parsed.city) setCity(parsed.city);
        if (parsed.keyword) setKeyword(parsed.keyword);
        if (parsed.page) setPage(parsed.page);
      });
      setIsInitialLoad(false);
      setTimeout(() => {
        restoringFromCache.current = false;
      }, 600);
    },
    storageKey: STORAGE_KEY,
  });

  const search = (val) => {
    // 关键修复：如果正在从缓存恢复，绝对不要执行搜索请求
    // 因为缓存的数据已经包含了完整的搜索结果，再次请求会导致数据覆盖或重复
    if (restoringFromCache.current) return;

    const url = [
      "/gin-api/job",
      "?option=filterBy-addressLevel2-category-keyword",
      `&addressLevel2=${val.city}`,
      "&category=",
      `&keyword=${val.keyword}`,
      `&take=${rowCount}`,
      "&skip=0",
    ];
    fetch(url.join(""))
      .then((response) => {
        if (response.status < 400) return response.json();
        throw new Error("请求数据失败");
      })
      .then((data) => {
        setList(data);
        setPage(2);
      })
      .catch((err) => window.console.error(err));
  };
  const handleChange = (val) => {
    // 关键修复：改变搜索条件时清除缓存，避免恢复过期的缓存数据
    sessionStorage.removeItem(STORAGE_KEY);
    // 关键修复：重置 page 为 1，清空 list，确保每次筛选都从第一页开始
    setPage(1);
    setList([]);
    search({
      city: val,
      status: "在招",
      keyword,
    });
    setCity(val);
  };
  const _handleChange = (event) => {
    setKeyword(event.target.value);
  };
  const _οnkeypress = (event) => {
    const keyCode = event.which || event.keyCode;
    if (keyCode === 13 && event.target.value !== "") {
      // 关键修复：进行新搜索时清除缓存
      sessionStorage.removeItem(STORAGE_KEY);
      // 关键修复：重置 page 为 1，清空 list，确保每次搜索都从第一页开始
      setPage(1);
      setList([]);
      search({
        city,
        status: "在招",
        keyword: event.target.value,
      });
    }
  };
  const load = () => {
    // 关键修复：如果正在从缓存恢复期间，绝对不要执行加载更多请求
    // 因为缓存的数据已经包含了所有页面的数据，再次请求会导致数据重复或覆盖
    if (restoringFromCache.current) return;

    const url = [
      "/gin-api/job",
      "?option=filterBy-addressLevel2-category-keyword",
      `&addressLevel2=${city}`,
      "&category=",
      `&keyword=${keyword}`,
      `&take=${rowCount}`,
      `&skip=${(page - 1) * rowCount}`,
    ];
    fetch(url.join(""))
      .then((response) => {
        if (response.status < 400) return response.json();
        throw new Error("请求数据失败");
      })
      .then((data) => {
        if (data.length > 0) {
          setList(list.concat(data));
          setPage(page + 1);
          setFlag(true);
        } else {
          setFlag(true);
          window.alert("已经到底了");
          document.getElementById("load").innerHTML = "已经到底了";
          document.getElementById("load").disabled = true;
        }
      })
      .catch((err) => window.console.error(err));
    setFlag(false);
  };

  useEffect(() => {
    document.title = "岗位/企业查询";
  }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="row pb-2 pt-1 bg-transparent">
          <div className="col">
            <input
              type="text"
              id="search"
              className="w-100 border-0 text-center rounded-pill"
              placeholder="按照企业/职位名称查询"
              value={keyword}
              onChange={_handleChange}
              onKeyPress={_οnkeypress}
              style={{ outline: 0, height: 35 }}
            />
          </div>
        </div>
        <div className="card border-0 shadow">
          <div className="card-body">
            <div className="row mb-3" style={{ fontSize: 14 }}>
              <div className="col">
                <CityDropdowns handleChange={handleChange} defaultValue={city} />
              </div>
            </div>
            {list?.map((item) => (
              <div key={item.id}>
                <RecruitmentRow1 {...item} fairId={"0"} />
                <hr style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }} />
              </div>
            ))}
            {flag === true ? (
              <button id="load" className="btn btn-block mx-auto" onClick={load}>
                点击加载更多
              </button>
            ) : (
              <div className="d-flex justify-content-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Navbar category="岗位" />
    </>
  );
};

export default KeywordSearch;
